import axios from 'axios';

const baseURL = (process.env.REACT_APP_ZABOTA_CHAT_URL || '').trim().replace(/\/$/, '');
const apiKey = (process.env.REACT_APP_ZABOTA_CHAT_API_KEY || '').trim();

export const isSupportChatConfigured = () =>
  process.env.REACT_APP_FEATURE_SUPPORT_CHAT === 'true' && Boolean(baseURL) && Boolean(apiKey);

const chatClient = axios.create({
  baseURL,
  headers: { 'X-API-Key': apiKey },
});

const createIdempotencyKey = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
};

export async function fetchSupportMessages(cabinetUserId, afterId) {
  const { data } = await chatClient.get('/chat/messages', {
    params: {
      cabinet_user_id: cabinetUserId,
      ...(afterId != null ? { after_id: afterId } : {}),
    },
  });
  return data.messages || [];
}

export async function postSupportMessage(cabinetUserId, fio, text) {
  const { data } = await chatClient.post(
    '/chat/messages',
    { cabinet_user_id: cabinetUserId, fio, text },
    { headers: { 'Idempotency-Key': createIdempotencyKey() } }
  );
  return data;
}

export async function postSupportMessageMedia(cabinetUserId, fio, file, caption) {
  const form = new FormData();
  form.append('cabinet_user_id', String(cabinetUserId));
  form.append('fio', fio);
  if (caption) form.append('caption', caption);
  form.append('file', file, file.name);

  const { data } = await chatClient.post('/chat/messages/media', form, {
    headers: { 'Idempotency-Key': createIdempotencyKey() },
  });
  return data;
}
